import React from 'react'
import { Icon, Link, ShowIf } from '@ztechapps/webui.util'

export const VendorProductPageLink = ({ url }: { url: string }) => {
  return (
    <ShowIf condition={!!url}>
      <Link href={url} target="_blank">
        <Icon name="external-link" title="Navigate to vendor product page." />
      </Link>
    </ShowIf>
  )
}
